import { MutationTree } from "vuex";
import Vue from "vue";
import { IPropertyEditState } from "../property-states.store";
import propertyKeuringPlatformTypesStore from "./property-keuring-platform-types.store";
import { IKeuringsPlatformInfoModel, KeuringsPlatformInfoModel, IKeuringPublishInfoRequest, KeuringPublishInfoRequest } from "../../../../models/property/property-keuring-platform.model";


const keuringPlatformMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_ASSIGN_VALUE]: (state: IPropertyEditState, payload: IKeuringPublishInfoRequest) => {
    Object.keys(payload).forEach(key => Vue.set(state.keuringPlatform, key, payload[key]))
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_RESET]: (state: IPropertyEditState) => {
    state.keuringPlatform = new KeuringPublishInfoRequest({});
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_AGENCY_ASSIGN_VALUE]: (state: IPropertyEditState, keuringPlatform: IKeuringsPlatformInfoModel) => {
    Object.keys(keuringPlatform).forEach(key => Vue.set(state.keuringPlatform.AgencyInfo, key, keuringPlatform[key]))
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_AGENCY_RESET]: (state: IPropertyEditState) => {
    state.keuringPlatform.AgencyInfo = new KeuringsPlatformInfoModel({});
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_OWNER_ASSIGN_VALUE]: (state: IPropertyEditState, keuringPlatform: IKeuringsPlatformInfoModel) => {
    Object.keys(keuringPlatform).forEach(key => Vue.set(state.keuringPlatform.OwnerInfo, key, keuringPlatform[key]))
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_OWNER_RESET]: (state: IPropertyEditState) => {
    state.keuringPlatform.OwnerInfo = new KeuringsPlatformInfoModel({});
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_CONTACT_INFO_ASSIGN_VALUE]: (state: IPropertyEditState, keuringPlatform: IKeuringsPlatformInfoModel) => {
    Object.keys(keuringPlatform).forEach(key => Vue.set(state.keuringPlatform.ContactInfo, key, keuringPlatform[key]))
  },

  [propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_CONTACT_INFO_RESET]: (state: IPropertyEditState) => {
    state.keuringPlatform.ContactInfo = new KeuringsPlatformInfoModel({});
  },
}
export default keuringPlatformMutations;